<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <h4 v-if="entity.id">Editing {{ entity.name }} Spreadsheet</h4>
        <div v-if="tab === 'main'">
          <div class="clearfix" slot="admin-content" id="location-content">
            <div class="col-xs-12 gap" v-if="entity.id">
              <div class="text-center">
                <div class="shadow platform">
                  <div class="inner-tab-outer">
                      <span @click="visible = 'spreadsheet'" :class="[ visible=== 'spreadsheet' ? 'vis' : '' ]" style="border-right:none;">Info</span>
                      <span @click="visible = 'details'" :class="[ visible === 'details' ? 'vis' : '' ]">Details</span>
                  </div>
                  <div class="inner-tab-outer">
                      <span @click="visible = 'tariff'" :class="[ visible === 'tariff' ? 'vis' : '' ]" style="border-top:none;">Tariffs</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="visible === 'spreadsheet'">
            <div class="col-xs-12 col-sm-6 main-location-details left top-small">
              <div class="form-group">
                <label for="sd-name" class="form-label">Name</label>
                <input type="text" class="form-control" id="sd-name" v-model="entity.name"/>
              </div>
              <div class="form-group">
                <label for="sd-date-format" class="form-label">Date Format</label>
                <input type="text" class="form-control" id="sd-date-format" v-model="entity.dateFormat"/>
              </div>
              <div v-show="entity.id" class="form-group">
                <label for="file" class="form-label">Upload Tariff</label>
                <input type="file" id="file" ref="file" class="form-control" @change="handleFileUpload()"/>
                <button v-show="file" class="btn btn-primary sq" @click="upload()" :disabled="uploading">Upload</button>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
              <div class="form-group">
                <label for="sd-email" class="form-label">Notification Email</label>
                <input type="text" class="form-control" id="sd-email" v-model="entity.notificationEmail"/>
              </div>
              <div class="form-group">
                <label for="sd-spreadsheet-type" class="form-label">Spreadsheet Type</label>
                <select class="form-control" id="sd-spreadsheet-type" v-model="entity.spreadsheetType">
                  <option value=""></option>
                  <option v-for="(opt, i) in getSystemOptions('SPREADSHEET_TYPE')" :value="opt.id">{{ opt.name }}</option>
                </select>
              </div>
              <div class="form-group">
                <label for="sd-email" class="form-label">Allow Old Tariff End Date Update?</label>
                <div class="material-switch">
                  <input id="maritime" type="checkbox" v-model="entity.allowOldTariffEndDateUpdate"/>
                  <label for="maritime" class="label-success"></label>
                </div>
              </div>
            </div>
          </div>
          <div v-show="visible === 'details'">
            <div class="clearfix bg-wht col-xs-12">
              <basic-details :dets="basicDetails" :parent="entity.id" :properties="this.properties" type="main"/>
            </div>
          </div>
          <div v-show="visible === 'tariff'">
            <div class="clearfix bg-wht col-xs-12">
              <tariff-details :dets="tariffs" :parent="entity.id" :getForParent="getForParent" :visible="visible === 'tariff'"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import BasicDetails from './BasicDetails'
  import TariffDetails from './TariffDetails'
  import SheetMixin from './SheetMixin'
  export default {
    name: 'SpreadsheetDescriptor',
    mixins: [AdminEntityMixin, HelperMixin, SheetMixin],
    components: {
      Autocomplete,
      BasicDetails,
      TariffDetails
    },
    data () {
      return {
        init: false,
        visible: 'spreadsheet',
        uploading: false,
        file: null,
        transformForUpdate: {
          entityType: this.toMinus,
          spreadsheetType: this.toMinus,
          data: this.toMinus,
          dataType: this.toMinus,
          tariff: this.toMinus,
          parent: this.toMinus,
          offset: this.toZero,
          skipRows: this.toZero,
          continuousNoOfRows: this.toZero,
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Spreadsheet Descriptors',
        editEntityScreen: 'Admin - Edit/View Spreadsheet Descriptor',
        tab: 'main',
        parentSearchResults: [],
        parentSearchText: '',
        children: [],
        entity: {
          id: null,
          parent: null,
          name: null,
          entityType: this.sheetDescMain,
          tabName: null,
          property: null,
          spreadsheetType: null,
          data: null,
          dataType: null,
          tariff: null,
          cell: null,
          currency: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          mask: null,
          offset: null,
          dateFormat: null,
          actualValue: null,
          notificationEmail: null,
          repeating: null,
          allowOldTariffEndDateUpdate: null,
          skipRows: null,
          continuousNoOfRows: null,
          deleted: null,
          externalId: null
        },
        entityName: 'spreadsheet-descriptor',
        boxes: [
          {
            prop: 'entityType',
            id: 'id'
          },
          {
            prop: 'spreadsheetType',
            id: 'id'
          },
          {
            prop: 'data',
            id: 'id'
          },
          {
            prop: 'dataType',
            id: 'id'
          },
          {
            prop: 'tariff',
            id: 'id'
          }
        ]
      }
    },
    computed: {
      isValid () {
        return this.entity.entityType
      },
      basicDetails () {
        return this.children.filter(obj => this.filterByCode(obj.entityType, this.sheetDescLookupHeader))
      },
      tariffs () {
        return this.children.filter(obj => this.filterByCode(obj.entityType, this.sheetDescLookup))
      },
      properties () {
        return this.$store.getters['systemOption/tariffDescriptorProperty']
      }
    },
    watch: {
      parentSearchText (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updateParentSearchResults(newVal)
        }
      },
      file () {
        this.uploading = false
      },
      '$route' (newVal, oldVal) {
        this.visible = 'spreadsheet'
        this.file = null
        this.getRelatedData()
      },
      tariffs (newVal, oldVal) {
        newVal.forEach(obj => {
          if (!obj.hasOwnProperty('loadedChildren')) {
            this.$set(obj, 'loadedChildren', true)
            this.getForParent(obj.id)
            .then(({data}) => {
              this.$set(obj, 'children', data.map(o => this.unwrapData(o)))
              this.$nextTick(() => {
                this.init = true
              })
            }).catch(err => console.log(err))
          }
        })
      }
    },
    methods: {
      filterByCode (entityType, id) {
        return entityType === id
      },
      updateParentSearchResults (str) {
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('spreadsheet-descriptor'), { params: { name: str } })
          .then(({data}) => {
            if (str === this.parentSearchText) {
              this.parentSearchResults = data
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      displayParent (p) {
        let str = ''
        if (p.name) {
          str += p.name
        }
        return str
      },
      selectParent (p) {
        this.entity.parent = p
        this.parentSearchText = ''
        this.parentSearchResults = []
      },
      getBaseData () {
        return {
          id: null,
          parent: null,
          name: null,
          entityType: this.sheetDescMain,
          tabName: null,
          property: null,
          spreadsheetType: null,
          data: null,
          dataType: null,
          tariff: null,
          cell: null,
          currency: null,
          startRow: null,
          endRow: null,
          startColumn: null,
          endColumn: null,
          mask: null,
          offset: null,
          dateFormat: null,
          actualValue: null,
          notificationEmail: null,
          repeating: null,
          skipRows: null,
          continuousNoOfRows: null,
          deleted: null,
          externalId: null
        }
      },
      getForParent (parent) {
        return this.$http.get(API.GET_ENTITIES('spreadsheet-descriptor'), {
          params: {
            parent: parent
          }
        })
      },
      getRelatedData () {
        if (this.entity.id !== null && this.entity.id > 0) {
          event.$emit('loading-on', { title: 'Setting up Spreadsheet' })
          this.getForParent(this.entity.id)
          .then(({data}) => {
            this.children = data.map(obj => this.unwrapData(obj))
          }).catch(err => {
            console.log(err)
            event.$emit('toast', { type: 'error', message: 'Not all children could be loaded. Please try refeshing or contact support' })
          }).then(() => {
            event.$emit('loading-off')
          })
        }
      },
      handleFileUpload () {
        this.file = this.$refs.file.files[0]
      },
      upload () {
        this.uploading = true
        const data = new FormData()
        data.append('file', this.file)
        data.append('descriptorName', this.entity.name)
        data.append('startImport', 'true')
        const headers = { 'Content-Type': 'multipart/form-data' }

        this.$http.post(API.TARIFF_FILE_UPLOAD, data, { headers })
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'File uploaded' })
          })
          .catch(err => {
            console.log(err)
            event.$emit('toast', { type: 'error', message: 'Upload failed' })
          })
          .finally(() => {
            this.file = null
            this.$refs.file.value = null
            this.uploading = false
          })
      }
    },
    mounted () {
      this.getRelatedData()
      this.file = null
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/SpreadsheetDescriptor/SpreadsheetDescriptor.vue